import { useEffect } from "react";
import { useSearchParams } from "next/navigation";

export const useSearchQuerySync = ({ setSearch }) => {
  const searchParams = useSearchParams();

  useEffect(() => {
    const query = searchParams.get("q") || searchParams.get("search");
    if (query) {
      setSearch(query);
    }
  }, []);

  useEffect(() => {
    if (!searchParams.get("q") && !searchParams.get("search")) {
      setSearch("");
    }
  }, [searchParams, setSearch]);
};
